namespace GeniuzPOS.PosShift {
    export class PsPosMoneyCountColumns {
        static columnsKey = 'PosShift.PsPosMoneyCount';
    }
}
